module.exports = __webpack_public_path__ + "img/IMG_9366-Editar.571fbb6f.jpg";